module.exports = __webpack_public_path__ + "img/TYS-5.852d2a3f.jpg";